<template>
	<el-dialog title="选择优惠券" :visible.sync="dialog" width="880px" :close-on-click-modal="false">
		<div>
			<div class="coupon-content">
				<div class="flex-between flex-wrap">
					<div class="coupon" v-for="(item, index) in list" :key="item.id" @click="changeCou(item.id)" :class="couponId == item.id?'active':''">
						<div class="item-top flex-between flex-center">
							<div class="item-top-left">
								<div>{{item.minusAmount}}元</div>
								<div>满减券</div>
							</div>
							<div class="item-top-center">
								<div>{{item.name}}</div>
								<div>适用平台：全平台</div>
							</div>
						</div>
						
						<div class="item-bottom">
							有效期: {{item.endTime}}
						</div>
						<div class="item-hr flex-between flex-center">
							<div class="item-left"></div>
							<div class="item-right"></div>
						</div>
						<img v-if="item.id==couponId" src="@/assets/images/radio.png"/>
					</div>
				</div>
				
				<div class="coupon-title" v-if="noList.length > 0">以下不适用于此订单</div>
				
				
				<div class="flex-between flex-wrap">
					<div class="coupon" v-for="(item, index) in noList" :key="item.id">
						<div class="item-top flex-between flex-center">
							<div class="item-top-left">
								<div style="color: rgba(7, 11, 19, 0.4);">{{item.minusAmount}}元</div>
								<div style="color: rgba(7, 11, 19, 0.4);">满减券</div>
							</div>
							<div class="item-top-center">
								<div style="color: rgba(7, 11, 19, 0.4);">{{item.name}}</div>
								<div style="color: rgba(7, 11, 19, 0.4);">适用平台：全平台</div>
							</div>
						</div>
						
						<div class="item-bottom" style="background: rgba(228, 228, 228, 1);">
							有效期: {{item.endTime}}
						</div>
						<div class="item-hr flex-between flex-center">
							<div class="item-left"></div>
							<div class="item-right"></div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="address-form-button flex-center flex-midden">
				<el-button class="address-form-button-sbumit" type="primary" :loading="isSubmit" @click="submitForm">确认使用</el-button>
				<el-button class="address-form-button-close" type="primary" :loading="false" @click="dialog = false;">不使用优惠券</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {getUserCouponList} from "@/api/user"
export default {
	name: 'addressSelect',
	data(){
		return {
			list:[],
			dialog:false,
			couponId:0,
			noList:[]
		}
	},
	methods:{
		init(id, price){
			this.couponId = id;
			getUserCouponList({price:price}).then(res=>{
				if(res.code == 1000){
					this.list = res.data[0]?res.data[0]:[];
					this.noList = res.data[1]?res.data[1]:[];
					this.dialog = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		submitForm(){
			this.dialog = false;
			this.$emit("success", this.couponId);
		},
		changeCou(id){
			if(this.couponId == id){
				this.couponId = 0;
			}else{
				this.couponId = id;
			}
		}
	}
}
</script>

<style scoped lang="scss">
	.coupon-title{
		font-size: 16px;
		line-height: 24px;
		color: #070B13;
		margin-bottom: 20px;
	}
	.coupon-content{
		height: 50vh;
		overflow: auto;
		.coupon{
			width: 386px;
			border: 1px solid #fff;
			background: rgba(248,248,248, 1);
			position: relative;
			height: 122px;
			margin-bottom: 20px;
			cursor: pointer;
			img{
				width: 24px;
				height: 24px;
				position: absolute;
				top:10px;
				right: 10px;
			}
			.item-hr{
				position: absolute;
				left: 0px;
				bottom: 22px;
				width: 386px;
				height: 20px;
				.item-left{
					width: 10px;
					height: 20px;
					background: #fff;
					border-radius: 0px 10px 10px 0px;
				}
				.item-right{
					width: 10px;
					height: 20px;
					background: #fff;
					border-radius: 10px 0px 0px 10px;
				}
			}
			.item-bottom{
				width: 100%;
				height: 32px;
				background: rgba(248,248,248, 1);
				font-size: 14px;
				line-height: 32px;
				text-align: center;
				color: rgba(7, 11, 19, 0.6);
			}
			.item-top{
				padding: 22px 16px 16px 0px;
				.item-top-left{
					color: rgba(233, 26, 18, 1);
					font-weight: 500; 
					width: 104px;
					flex: 0 0 104px;
					text-align: center;
					div{
						&:first-of-type{
							font-size: 24px;
							line-height: 26px;
						}
						&:last-of-type{
							font-size:12px;
							line-height: 26px;
						}
					}
				}
				.item-top-center{
					width: 100%;
					div{
						&:first-of-type{
							font-size: 16px;
							font-weight: 500;
							line-height: 20px;
							color: #070B13;
		
						}
						&:last-of-type{
							font-size: 12px;
							line-height: 20px;
							color: #070B13;
							opacity: 0.6;
						}
					}
				}
			}
		}
		
		.active{
			background: #FFF9F9;
			border: 1px solid #E91A12;
			.item-bottom{
				background: #FFF9F9;
			}
		}
	}
	::v-deep .el-button--primary:focus, .el-button--primary:hover{
		background: #E91A12;
		color: #FFFFFF;
		border: 1px solid #E91A12;
	}
	.address-form-button-sbumit{
		width: 180px;
		height: 46px;
		background: #E91A12;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: #FFFFFF;
		margin: 0px 20px;
	}
	.address-form-button-close{
		width: 180px;
		height: 46px;
		background: #fff;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color:rgba(7, 11, 19, 1);
		margin: 0px 20px;
	}
	::v-deep .el-dialog__body{
		padding: 0px 40px 40px;
	}
	::v-deep .el-dialog__header{
		text-align: center;
		padding: 30px 20px 20px;
	}
</style>